<template lang="html">
   <div class="login-back">
      <div class="row">
         <div class="col-12 col-md-6 col-lg-5 col-xl-4">
            <div class="row justify-content-center">
               <div class="col-12 col-lg-11">
                  <div class="login">
                     <div class="logo-box">
                        <img :src="lang.logo" alt="" class="logo">
                     </div>

                     <div v-if="page == 1">
                        <div class="h3">{{lang.main_text}}</div>
                        <div class="text-muted t3-5 ">{{lang.sub_text}}</div>
                        
                        <div>
                           <Form 
                              classBinding="row form-box"
                              :ref="LogInModel.forms.login.name" 
                              :forms="LogInModel.forms.login.forms" 
                              :formData="LogInModel.forms.login.data"
                           />
                           <div class="link-txt link t2-5  bold" @click="$store.commit('page',2)">{{lang.forgot_pass}}</div>
                           
                           <div class="btns">
                              <button class="btn btn-primary" :disabled="loading" @click="logIn({ref: $refs[LogInModel.forms.login.name],router:$router})">
                                 {{lang.login}} <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                              </button>
                           </div>
                        </div>
                     </div>
                     <div v-if="page == 2">
                        <Form 
                           classBinding="row form-box"
                           :ref="LogInModel.forms.forgot_password.name" 
                           :forms="LogInModel.forms.forgot_password.forms" 
                           :formData="LogInModel.forms.forgot_password.data"
                        />
                        <div class="link-txt link t2-5  bold" @click="$store.commit('page',1)">{{lang.back_login}}</div>
                        
                        <div class="btns">
                           <button class="btn btn-primary" :disabled="loading" @click="sendForgotPasswordRequest({ref: $refs[LogInModel.forms.forgot_password.name],router:$router})">
                              {{lang.send_token}} <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                           </button>
                        </div>
                     </div>
                     <div v-if="page == 3">
                        <Form 
                           classBinding="row form-box"
                           :ref="LogInModel.forms.validate_otp.name" 
                           :forms="LogInModel.forms.validate_otp.forms" 
                           :formData="LogInModel.forms.validate_otp.data"
                        />
                        <div class="link-txt link t2-5  bold" @click="$store.commit('page',1)">{{lang.back_login}}</div>
                        
                        <div class="btns">
                           <button class="btn btn-primary" :disabled="loading" @click="validateOTP({ref: $refs[LogInModel.forms.validate_otp.name],router:$router})">
                              {{lang.validate_otp}} <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-12 col-md-6 col-lg-7 col-xl-8 image-back">
            <div class="overlay"></div>
            <div class="copyright t2-5 ">&copy; {{main_lang.brand}} {{main_lang.copyright}}</div>
            <div class="txt-box">
               <div class="txt">
                  {{lang.side_text}}
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import login from "./login.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('login')
   },
   created(){
      utils.registerModule('login',login,this.$store)
   },
   components:{
      Form: () => import("clarks/components/form"),
   },
   data(){
      return {
         main_lang
      }
   },
   computed: {
      ...mapGetters([
         'LogInModel',
         'loading',
         'lang',
         'showLogIn',
         'page'
      ])
   },
   methods: {
      ...mapActions([
         'logIn',
         'resetPassword',
         'validateOTP',
         'sendForgotPasswordRequest',
         'resendOTP',
      ]),
   },
   mounted(){
      utils.registerModule('login',login,this.$store)
   }
}
</script>

<style lang="scss">
@import './styles/login.scss'
</style>